import React, { createContext, useContext, useState } from 'react'

const UIContext = createContext()

export const UIProvider = ({ children }) => {
  const [showAuth, setShowAuth]     = useState(false)
  const [showListPG, setShowListPG] = useState(false)

  return (
    <UIContext.Provider value={{ showAuth, setShowAuth, showListPG, setShowListPG }}>
      {children}
    </UIContext.Provider>
  )
}

export const useUI = () => useContext(UIContext)